import React, { type FunctionComponent, useEffect } from 'react'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import {
  useOrdersListBehaviour,
  type UseOrdersListBehaviourProps,
} from 'legacy/sections/orders/components/list/utils/ordersList.hooks'
import AppHeader from 'legacy/components/AppHeader'
import { OrdersListContent } from 'legacy/sections/orders/components/list/OrdersListContent'
import { OrdersBreadcrumbs } from 'legacy/sections/orders/components/breadcrumbs/OrdersBreadcrumbs'
import { usePickupOrderTour } from 'domains/pickup-settings/training-tour/pickupOrderTourSteps'
import { useNavContext } from 'gin-and-tonic/containers/nav/utils/NavContext'
import { usePickupTourStatus } from 'domains/pickup-settings/training-tour/usePickupTourStatus'

interface Props extends RetailerRouteComponentProps, UseOrdersListBehaviourProps {}

export const OrdersList: FunctionComponent<Props> = ({ orderType }) => {
  const behaviour = useOrdersListBehaviour({ orderType })
  const { isBlockedByModal } = useNavContext()
  const { isTourPending } = usePickupTourStatus('pickup_orders')

  const isPageReady = !behaviour.loading && !behaviour.error && !isBlockedByModal
  const { startTour: startPickupOrderTour } = usePickupOrderTour()

  useEffect(() => {
    if (isPageReady && orderType === 'pickup' && isTourPending) {
      // startPickupOrderTour()
    }
  }, [isPageReady, orderType, startPickupOrderTour, isTourPending])

  return (
    <OrdersListContent
      header={<AppHeader title={<OrdersBreadcrumbs orderType={orderType} />} />}
      behaviour={behaviour}
    />
  )
}
